class collectionSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }

  init() {
    this.swiper = new Swiper(".collectionsSwiper", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

customElements.define("collection-slider", collectionSlider);
class collectionEyewearSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }
  init() {
    var swiper = new Swiper(".collectionsSwiperSlider", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });    
  }
}

customElements.define("collection-eyewear-slider", collectionEyewearSlider);